import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'xux-close-icon',
  templateUrl: './xux-close-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxCloseIconComponent implements OnInit {
  public constructor() {}

  public ngOnInit() {}
}
